import * as React from 'react'
import { FormEvent, FunctionComponent } from 'react'
import { useFormikContext } from 'formik'
import { TextField } from '@fluentui/react'
import PostalCodeField from '../../Form/PostalCodeField'
import { AddressDto } from '../../../config/contactConfig'

type Props = {
    value: AddressDto
    namespace: string
}

const AddressField: FunctionComponent<Props> = ({ value, namespace }: Props) => {
    const { setFieldValue } = useFormikContext()

    return (
        <>
            <TextField
                label="Straat"
                value={value.street}
                onChange={(_: FormEvent, newValue?: string) => setFieldValue(`${namespace}.street`, newValue)}
            />
            <TextField
                label="Huisnr."
                value={value.number}
                onChange={(_: FormEvent, newValue?: string) => setFieldValue(`${namespace}.number`, newValue)}
            />
            <PostalCodeField
                label="Postcode"
                value={value.postalCode}
                onChange={(_: FormEvent, newValue?: string) => setFieldValue(`${namespace}.postalCode`, newValue)}
                country={value.country}
            />
            <TextField
                label="Plaats"
                value={value.locality}
                onChange={(_: FormEvent, newValue?: string) => setFieldValue(`${namespace}.locality`, newValue)}
            />
        </>
    )
}
export default AddressField
